<template>
  <div
    :class="{active: $store.getters['session/showMobileMenu']}"
    class="mobile-menu-component-container"
  >
    <div
      v-disableable="{disabled: $store.getters['session/onTour']}"
      class="close"
      @click="$store.commit('session/toggleMobileMenu', false)"
    />
    <div class="content">
      <beta-toggle />
      <div
        v-disableable="{blur: true, dim: true, disabled: $store.getters['session/onTour']}"
        class="heading"
      >
        <div class="account-container">
          <icon
            name="account"
            variant="white"
          />
        </div>
        <div class="details">
          <div class="name">
            Menu
          </div>
          <div class="spacer" />
          <div class="links">
            <template v-if="authenticated">
              <router-link
                :to="{name: 'profile'}"
                @click.native="$store.commit('session/toggleMobileMenu', false);"
              >
                Profile
              </router-link>
              <router-link
                :to="{name: 'support'}"
                @click.native="$store.commit('session/toggleMobileMenu', false);"
              >
                Support
              </router-link>
              <div @click="$store.commit('session/toggleMobileMenu', false); signOut()">
                Sign Out
              </div>
            </template>
            <template v-else>
              <router-link
                :to="{ name: 'signIn' }"
                @click.native="$store.commit('session/toggleMobileMenu', false);"
              >
                Log In
              </router-link>
              <router-link
                :to="{ name: 'signUp' }"
                @click.native="$store.commit('session/toggleMobileMenu', false);"
              >
                Create Account
              </router-link>
              <router-link
                :to="{name: 'support'}"
                @click.native="$store.commit('session/toggleMobileMenu', false);"
              >
                Support
              </router-link>
            </template>
          </div>
          <div class="spacer" />
          <div
            v-if="showUpgrade"
            class="upgrade"
            @click.prevent.stop="lockedAction"
          >
            <span>
              <icon
                name="lock"
                class="upgrade-icon"
                variant="516173"
              />
            </span>
            <span>Unlock</span>
          </div>
        </div>
      </div>
      <menu-list
        :mobile="true"
        :navigation-items="navigationItems"
        :on-tour="$store.getters['session/onTour']"
      />
      <menu-footer :on-tour="$store.getters['session/onTour']" />
    </div>
  </div>
</template>

<script>
import AuthenticationMixin from '@/mixins/authentication';
import GlobalMixin from '@/mixins/global';

import BetaToggle from '@components/singletons/beta-toggle';
import MenuFooter from '@components/ui/menu/footer';
import MenuList from '@components/ui/menu/list';
import Icon from '@components/singletons/icon';

export default {
  components: { BetaToggle, MenuFooter, MenuList, Icon },
  mixins: [AuthenticationMixin, GlobalMixin],
  computed: {
    navigationItems() {
      if (this.authenticated) {
        return this.$store.getters['navigationItems/menuItems'];
      }
      return [];
    },
    showUpgrade() {
      return !this.$store.getters['session/hasPaid'] && this.$store.getters['certifications/certificationsList'].length === 0;
    },
  },
  methods: {
    lockedAction() {
      this.$store.dispatch('ui/toggleUpsellModal', { show: true, source: { type: 'Mobile Menu Button' }});
    },
    showBookmarkTourtip(sequence) {
      return this.$store.getters['session/onTour'] && sequence === this.$store.getters['session/tourSequence'];
    },
    signOut() {
      this.$store.dispatch('session/signOut');
    },
  },
};
</script>

<style lang='scss' scoped>
  $sidebar-background: $grey-1 !default;

  .mobile-menu-component-container {
    bottom: 0;
    display: none;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    transition: 300ms all ease-in-out;
    transform: translate(100%, 0);
    z-index: 1000;

    @include breakpoint(small) {
      display: flex;
    }

    &.active {
      transform: none;
    }

    .account-container {
      background-color: #4fb9de;
      border-radius: 100%;
      margin-right: rem-calc(12);
      padding: rem-calc(12);
      height: rem-calc(16);
      width: rem-calc(16);

      img {
        width: 100%;
      }
    }

    .close {
      width: 15%;
    }

    .content {
      background-color: $sidebar-background;
      display: flex;
      flex: 1;
      flex-direction: column;
      overflow-y: scroll;
      padding-top: rem-calc(32);
      width: 80%;

      .heading {
        border-bottom: 1px solid #516173;
        display: flex;
        margin: 0 rem-calc(24);
        padding: rem-calc(16) 0;

        .details {
          display: flex;
          flex: 1;
          flex-direction: column;

          .name {
            color: white;
          }

          .upgrade {
            @include hlt-btn-1;
            height: rem-calc(20);
            font-size: rem-calc(15);
            margin-top: rem-calc(14);
            color: #516173;
            cursor: pointer;
            width: rem-calc(80);
            .upgrade-icon {
              width: 14px;
              margin-right: 5px;
            }
          }

          .spacer {
            flex: 1;
          }

          .links {
            display: flex;
            font-size: rem-calc(14);

            > * {
              color: #7f8fa4;
              border-left: 1px solid #7f8fa4;
              padding: 0 rem-calc(6);

              &:first-child {
                border: none;
                padding-left: 0;
              }

              &:last-child {
                padding-right: 0;
              }
            }
          }
        }
      }

      .menu-list-container {
        padding: rem-calc(12) rem-calc(24);
      }
    }

    .beta-toggle-component-container {
      margin-left: rem-calc(32);
    }

    /deep/ .v-popover span {
      width: 100%;
    }

    .menu-footer-container {
      padding: rem-calc(16);
    }
  }
</style>
